

import React from 'react';
import axios from 'axios';


import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ResendLink from '../../Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';


const appVars = AppVars.getInstance();

class UpdatePasswordFormView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return(
            <div>
            <div role="banner">
            {/* HEADER AND TITLE RENDERING BASED ON STATE */}
            <div>
            <a href = {appVars.getAppHomeURL(this.props.style)}>
                <Image className = {`${this.props.passwordLoading === false ? "login-log-resend" : "none"}`} src={require('../../../../static/images/' + this.props.style +'/toyota-logo.svg').default} alt="Toyota"/></a>
            </div>

            {/* Titles */}
            <h1 className="title__TO block" style={{'marginBottom': '30px', 'marginTop': '70px', 'width':'auto'}}>
                {constants.PASSWORD_TITLE}
            </h1>
            <h1 className={`title__TO ${this.props.passwordLoading === true ? "block" : "none"}`} style={{'marginBottom': '38.5px', 'marginTop': '224px', 'width':'auto'}}>
                {constants.PASSWORD_LOADING_TITLE}
            </h1>

            {/* Loading gifs for page load and reset email sending */}
            <div className={`${this.props.passwordLoading === true ? "activate-background" : "none" }`} a>
                <div className="spinner">
                <img className='spinner-img' src={Loader} alt="Loading" />
                </div>
            </div>
            </div>

            {/* BODY OF THE COMPONENT */}
            <div role = "main" className={`${this.props.passwordLoading === false ? "body-container__TO" : "none" }`}>
                {/* Password State: PASSWORD */}
                <Form id = "updatePasswordForm" noValidate validated = {this.props.isPasswordValid && this.props.isConfirmPasswordValid} onSubmit = {this.props.reset}>
            {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
            <Form.Group id = "createPasswordGroupAlone" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatPassword === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.passwordFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "label-red__TO" : ""}
                `}>
                Password
                <span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createPassword__TO"
                    data-testid = "createPassword"
                    aria-label = "Password"
                    as = "input"
                    type = "password"
                    name = "password"
                    placeholder = ""
                    value = {this.props.password}
                    onChange = {this.props.handlePasswordChange}
                    onFocus = {this.props.onFocusPassword}
                    onBlur = {this.props.onBlurPassword}
                    bsPrefix = {`${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createPasswordAlert" 
                data-testid = "createPasswordError" 
                className = {`logon-item-error__TO ${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "false" : "true"}`}
            >
                Minimum of 8 characters and a maximum of 16. Must have at least three of the following: uppercase letter, lowercase letter, number (0-9) and/or special character/symbol. Password is case-sensitive.
            </div>
            {/* <div
                id = "createPasswordAlert"
                data-testid = "createPasswordError"  
                className = {`logon-item-error__TO ${this.props.isPasswordUsed === true && this.props.passwordFocus === false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${this.props.isPasswordUsed === true && this.props.passwordFocus === false ? "false" : "true"}`}
                >
                        Password has been used previously.
            </div> */}
            </Form.Group>
            <Form.Group id = "createPasswordGroupAlone" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatConfirmPassword === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.confirmPasswordFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isConfirmPasswordValid === false && this.props.confirmPasswordFocus === false ? "label-red__TO" : ""}
                `}>
               Confirm  Password
                <span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "confirmPassword__TO"
                    data-testid = "createPassword"
                    aria-label = "Password"
                    as = "input"
                    type = "password"
                    name = "password"
                    placeholder = ""
                    value = {this.props.confirmPassword}
                    onChange = {this.props.handleConfirmPasswordChange}
                    onFocus = {this.props.onFocusConfirmPassword}
                    onBlur = {this.props.onBlurConfirmPassword}
                    bsPrefix = {`${this.props.isConfirmPasswordValid === false && this.props.confirmPasswordFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createPasswordAlert" 
                data-testid = "createPasswordError" 
                className = {`logon-item-error__TO ${this.props.isConfirmPasswordValid === false && this.props.confirmPasswordFocus === false? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isConfirmPasswordValid === false && this.props.confirmPasswordFocus === false ? "false" : "true"}`}
            >
                Passwords do not match.
            </div>
            </Form.Group>
            {/* <div className="required require-left"><span><span id="redStar">*</span>Required</span></div> */}
            <div>
            <Button style = {{"marginTop" : "30px"}} data-testid = "createPasswordButton" bsPrefix = "button__TO " type = "submit" >Reset Password</Button>
            </div>

        </Form>

                
            </div>

            {/* Links */}
            <div role = "complementary">     
            <ResendLink
                    lineText="Already have a Toyota account?"
                    linkAddress="/"
                    linkText="SIGN IN"
                    className="inline-block"
                />
            </div>
            <div className={`${this.props.loadingReset === true ? "resend-background" : "none" }`}>
                <div className="spinner">
                    <img className='spinner-img' src={Loader} alt="Loading"/>
                </div>
            </div>
        </div>
        )
    }

}

export default UpdatePasswordFormView